import { Check } from 'lucide-react';

function StepCircle({ status }) {
  if (status === 'done') {
    return (
      <div className="w-5 h-5 rounded-full bg-primary flex items-center justify-center flex-shrink-0">
        <Check size={10} strokeWidth={2.5} className="text-white" />
      </div>
    );
  }
  if (status === 'active') {
    return <div className="w-5 h-5 rounded-full bg-accent flex items-center justify-center flex-shrink-0" />;
  }
  return <div className="w-5 h-5 rounded-full border-2 border-slate-200 flex-shrink-0" />;
}

export function StepItem({ label, sublabel, status, isLast }) {
  const subColor = status === 'active' ? 'text-accent' : status === 'done' ? 'text-slate-500' : 'text-slate-400';
  return (
    <div className="flex gap-2">
      <div className="flex flex-col items-center">
        <StepCircle status={status} />
        {!isLast && <div className="w-px flex-1 min-h-[14px] bg-slate-200 mt-0.5" />}
      </div>
      <div className={`flex-1 min-w-0 ${isLast ? '' : 'pb-3.5'}`}>
        <p className={`text-[11.5px] font-semibold ${status === 'pending' ? 'text-slate-400' : 'text-slate-800'}`}>
          {label}
        </p>
        {sublabel && <p className={`text-[10.5px] mt-0.5 ${subColor}`}>{sublabel}</p>}
      </div>
    </div>
  );
}
